import React from "react";
import { FaClipboardList } from "react-icons/fa";
import EmptyState from "./EmptyState";
import ActivityTable from "./ActivityTable";

function TomorrowPlan({ tasks = [], onRowClick }) {
  if (tasks.length === 0) {
    return (
      <EmptyState
        icon={<FaClipboardList size={22} />}
        title="No plan yet"
        message="Nothing has been planned for tomorrow."
        subMessage="Plans appear here once an employee submits their tomorrow plan."
      />
    );
  }

  return (
    <ActivityTable
      activities={tasks}
      showIndex
      showProgress={false}
      showStatus
      showNotes
      onRowClick={onRowClick}
    />
  );
}

export default TomorrowPlan;
